import actionTypes from '../constants/action-types';
import DEFAULT_OPTIONS from '../constants/default-options';

const copyElement = (elementId, options = DEFAULT_OPTIONS) => ({
  type: actionTypes.COPY_ELEMENT,
  payload: {
    elementId,
    options,
  },
});

export default copyElement;
